import { render, staticRenderFns } from "./AnswerSlide.vue?vue&type=template&id=7993a192"
import script from "./AnswerSlide.vue?vue&type=script&lang=js"
export * from "./AnswerSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports